export default __webpack_public_path__ + "static/Avenir-Medium-043601295d2b1aa365644492ee85513e.ttf";